import React from "react";
import { useEffect, useState } from "react";
import DashboardCard from "../../../components/DashboardCard";
import MyFiles from "../../../assets/images/MyFiles.svg";
import { useHistory } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { BuildingStorefrontIcon } from "@heroicons/react/24/solid";
import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import { PERMISSIONS } from "../../PermissionsConstants";
import { accountAtom } from "../../Login/atoms/AccountAtom";
import {
  mainSelectedTab,
  permittedTabs,
} from "../../CarrierAgreementMgmt/atoms";
import { RedirectTo } from "../../../routes/RedirectTo";
import useGetAllVendorsCount from "../../CarrierAgreementMgmt/Vendor/hooks/useGetVendorCount";

const NewVendorCard = () => {
  const [caCount, setCACount] = useState("...");
  const modulePermission = PERMISSIONS.permission_vendor_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  const useraccount = useRecoilValue(accountAtom);

  const history = useHistory();
  const [connection, setConnection] = useState<any>(null);

  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const [usersTabs] = useRecoilState(permittedTabs);
  const { data: vendorCount } = useGetAllVendorsCount();

  return (
    <div
      className="p-2 pr-4 bg-white text-primary rounded-lg animate-fade-in-down2 shadow-md hover:text-white hover:bg-VividBlue"
      onClick={() => {
        if (userPermissions.includes(modulePermission)) {
          RedirectTo({
            urlPath: "/vendortab/vendor",
            history: history,
            usersTabs: usersTabs,
            setSelectedIndex: setSelectedIndex,
          });
        }
      }}
    >
      <DashboardCard
        text="Vendor"
        count={vendorCount}
        image={
          <BuildingStorefrontIcon className="text-white bg-VividBlue rounded-md h-7 w-7 p-1" />
        }
        hasAccess={userPermissions.includes(modulePermission)}
      />
    </div>
  );
};

export default NewVendorCard;
